/**
 * The type of the action which toggles the remote video menu visibility.
 *
 * {
 *     type: TOGGLE_REMOTE_VIDEO_MENU,
 *     participant: Object,
 *     visible: boolean
 * }
 */
export const TOGGLE_REMOTE_VIDEO_MENU = 'TOGGLE_REMOTE_VIDEO_MENU';

export const TOGGLE_CONNECTION_CONTAINER = 'TOGGLE_CONNECTION_CONTAINER';
